export default {
  GET_VIDEO_SYNTH_PAGE_INFO: '/Share/VideoSynth', // 获取落地页面信息
};
